import { neutral10, spacing5 } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const CheckoutActionsLeafPayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing5};
  border: 1px solid ${neutral10.hex};
  padding: ${spacing5};
`;

export const CheckoutActionsMessageWrapper = styled.div`
  margin-top: ${spacing5};
`;

export const CheckoutActionsRequestWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: fit-content;
  margin: ${spacing5} auto 0;
`;

export const CheckoutActionsRequestTooltipWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: calc(100% + ${spacing5});
  transform: translateY(-50%);
`;
